var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.063,
    height: 34,
    rx: 3,
    fill: "#FF2953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.397 11.948h3.715c1.723 0 2.967.243 3.732.73.77.487 1.156 1.256 1.156 2.308 0 .708-.189 1.297-.565 1.768-.377.47-.92.766-1.627.888v.083c.88.16 1.524.479 1.935.955.417.47.625 1.11.625 1.917 0 1.09-.394 1.945-1.181 2.565-.782.614-1.872.921-3.27.921h-4.52V11.948Zm2.046 5.013h1.969c.855 0 1.48-.13 1.874-.39.394-.266.59-.714.59-1.345 0-.57-.213-.982-.641-1.236-.422-.255-1.096-.382-2.02-.382h-1.772v3.353Zm0 1.61v3.844h2.174c.856 0 1.5-.158 1.934-.473.44-.321.66-.825.66-1.511 0-.63-.223-1.098-.668-1.403-.445-.304-1.121-.456-2.029-.456h-2.071Z",
    fill: "#FDFDFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35.063v34H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.ce73db3581733f8742359173ab465be7.svg";
export { ForwardRef as ReactComponent };